const TABLE_ROW = /^ {0,3}\|/
const TABLE_DELIMITER = /^ {0,3}\|[ \t|:-]*-[ \t|:-]*$/
const FENCE = /^ {0,3}(```|~~~)/

const cellCount = (row: string): number =>
  row.trim().replace(/^\|/, "").replace(/\|$/, "").split("|").length

/**
 * The agent sometimes goes on with a table after a blank line, and those rows
 * have no header. Markdown then shows them as text full of pipes, so they get
 * an empty header of their own.
 */
function headTableRows(text: string): string {
  const lines = text.split("\n")
  const out: string[] = []
  let fence: string | undefined
  lines.forEach((line, i) => {
    const marker = FENCE.exec(line)?.[1]
    if (marker && !fence) fence = marker
    else if (marker === fence) fence = undefined
    const opensRows =
      !fence &&
      TABLE_ROW.test(line) &&
      !TABLE_DELIMITER.test(line) &&
      (i === 0 || lines[i - 1].trim() === "") &&
      !TABLE_DELIMITER.test(lines[i + 1] ?? "")
    if (opensRows) {
      const columns = cellCount(line)
      out.push(`|${"  |".repeat(columns)}`, `|${" --- |".repeat(columns)}`)
    }
    out.push(line)
  })
  return out.join("\n")
}

/**
 * Turn Slick AI text into the markdown the renderer should see: rows without
 * a header get one (see headTableRows), and single newlines become hard line
 * breaks (two trailing spaces + newline). Markdown renderers treat a single \n
 * as a soft break and merge the lines into one paragraph — Slick AI messages
 * (fleet reports, alerts) are mostly plain text with single newlines, so
 * without this a multi-line report collapses into a single run-on paragraph.
 * Regular MUC rooms (e.g. dispatcher "Biuro" rooms that receive scheduled
 * fleet reports) need it too.
 */
export function toAgentMarkdown(text: string): string {
  return headTableRows(text).replace(/\n/g, "  \n")
}
